import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { GalleryType } from '@app/core/plugin';
import { CoreStateService } from '@app/core/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Gallery } from '../../utils/home';

@Component({
  selector: 'app-card-student',
  templateUrl: './card-student.component.html',
  styleUrls: ['./card-student.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardStudentComponent implements OnInit {
  public readonly gallery = Gallery;

  public gallery$: Observable<GalleryType>;

  constructor(private coreStateService: CoreStateService) {}

  public ngOnInit() {
    this.gallery$ = this.coreStateService.plugin$.pipe(map((plugin) => plugin.handler.home.gallery));
  }
}
